import {
  Search,
  MapPin,
  ShieldCheck,
  Home,
  UtensilsCrossed,
  ShoppingBag,
  User,
  Star,
  Clock,
} from "lucide-react";

const ITEMS = [
  { img: "/showcase/sultans-grill.png", name: "Sultan's Grill", cuisine: "Mixed Grill", time: "20 min", rating: "4.9" },
  { img: "/showcase/bite-of-beirut.png", name: "Bite of Beirut", cuisine: "Shawarma", time: "25 min", rating: "4.8" },
  { img: "/showcase/manila-halal-hub.png", name: "Manila Halal Hub", cuisine: "Filipino Halal", time: "18 min", rating: "4.9" },
];

// Clean, self-contained smartphone app-screen placeholder (pure CSS + brand imagery).
export const PhoneMockup = () => {
  return (
    <div className="relative mx-auto w-[280px] max-w-full">
      <div aria-hidden className="absolute -inset-6 -z-10 rounded-[3rem] bg-halalgo-green-100/60 blur-2xl" />
      <div className="rounded-[2.6rem] bg-halalgo-ink p-2.5 shadow-lift-md ring-1 ring-black/20">
        <div className="relative overflow-hidden rounded-[2.1rem] bg-white">
          {/* notch */}
          <div className="absolute left-1/2 top-2 z-10 h-5 w-24 -translate-x-1/2 rounded-full bg-halalgo-ink" />

          {/* app header */}
          <div className="bg-halalgo-green-600 px-4 pb-4 pt-8 text-white">
            <div className="flex items-center justify-between">
              <span className="inline-flex items-center gap-1 text-[11px] font-medium">
                <MapPin className="h-3.5 w-3.5" /> Deliver to{" "}
                <span className="font-semibold">Makati</span>
              </span>
              <ShoppingBag className="h-4 w-4" />
            </div>
            <p className="mt-3 text-lg font-bold leading-none">Halal Made Easy</p>
            <p className="mt-1 text-[11px] text-white/85">100% Halal · Trusted · Fast</p>
            <div className="mt-3 flex items-center gap-2 rounded-lg bg-white px-3 py-2 text-halalgo-ink/50">
              <Search className="h-4 w-4" />
              <span className="text-xs">Search halal kitchens...</span>
            </div>
          </div>

          {/* list */}
          <div className="px-4 py-3">
            <p className="mb-2 text-[11px] font-bold uppercase tracking-wide text-halalgo-kraft-700">
              Trusted kitchens near you
            </p>
            <div className="space-y-2.5">
              {ITEMS.map((it) => (
                <div
                  key={it.name}
                  className="flex items-center gap-3 rounded-xl border border-halalgo-kraft-100 p-2"
                >
                  <img
                    src={it.img}
                    alt={it.name}
                    className="h-12 w-12 rounded-lg object-cover"
                    loading="lazy"
                  />
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-1">
                      <p className="truncate text-sm font-semibold text-halalgo-ink">{it.name}</p>
                      <ShieldCheck className="h-3.5 w-3.5 shrink-0 text-halalgo-green-600" />
                    </div>
                    <p className="truncate text-[11px] text-halalgo-ink/55">{it.cuisine}</p>
                    <div className="mt-0.5 flex items-center gap-2 text-[10px] text-halalgo-ink/55">
                      <span className="inline-flex items-center gap-0.5">
                        <Star className="h-3 w-3 fill-halalgo-kraft-500 text-halalgo-kraft-500" />{" "}
                        {it.rating}
                      </span>
                      <span className="inline-flex items-center gap-0.5">
                        <Clock className="h-3 w-3" /> {it.time}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* bottom nav */}
          <div className="flex items-center justify-around border-t border-halalgo-kraft-100 px-4 py-2.5 text-halalgo-ink/35">
            <Home className="h-5 w-5 text-halalgo-green-700" />
            <UtensilsCrossed className="h-5 w-5" />
            <ShoppingBag className="h-5 w-5" />
            <User className="h-5 w-5" />
          </div>
        </div>
      </div>
    </div>
  );
};
